import React from 'react'
import ContentLoader from "react-content-loader"

const styleContent = {
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}

const WidgetLoader = () => (
  <ContentLoader
    speed={1}
    backgroundColor="#ffffff"
    foregroundColor="#ededed"
    style={styleContent}
  >
    <rect
      x="0"
      y="0"
      rx="10"
      ry="10"
      width="100%"
      height="100%"
    />
  </ContentLoader>
)

export default WidgetLoader